import Vue from 'vue'
import Router from 'vue-router'
const Home = resolve => require(['@/views/Home'], resolve)
const Planning = resolve => require(['@/views/Planning'], resolve)
const Qualityshield = resolve => require(['@/views/Qualityshield'], resolve)
const Classiccase = resolve => require(['@/views/Classiccase'], resolve)
const Academicvalue = resolve => require(['@/views/Academicvalue'], resolve)
const Contactus = resolve => require(['@/views/Contactus'], resolve)
const Educational = resolve => require(['@/views/Educational'], resolve)
const List = resolve => require(['@/views/EducationalList'], resolve)
const Item = resolve => require(['@/views/EducationalItem'], resolve)

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Planning',
      name: 'Planning',
      component: Planning
    },
    {
      path: '/Qualityshield',
      name: 'Qualityshield',
      component: Qualityshield
    },
    {
      path: '/Classiccase',
      name: 'Classiccase',
      component: Classiccase
    },
    {
      path: '/Academicvalue',
      name: 'Academicvalue',
      component: Academicvalue
    },
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    },
    {
      path: '/Educational',
      name: 'Educational',
      redirect: '/Educational/List',
      component: Educational,
      children: [
        {
          path: 'List',
          name: 'EducationalList',
          component: List
        },
        {
          path: 'Item/:id',
          name: 'EducationalItem',
          component: Item
        }
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js